import { render, staticRenderFns } from "./HomeOrderServiceAdmin.vue?vue&type=template&id=44c78f36&scoped=true&"
import script from "./HomeOrderServiceAdmin.vue?vue&type=script&lang=js&"
export * from "./HomeOrderServiceAdmin.vue?vue&type=script&lang=js&"
import style0 from "./HomeOrderServiceAdmin.vue?vue&type=style&index=0&id=44c78f36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c78f36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VIcon,VListItem,VListItemContent,VListItemTitle,VRow,VSkeletonLoader})
